import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import styles from "./index.module.scss";
import API from "../../api";
import Item from "./item";

const WhiteList = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(false);
  const [userIdInput, setUserIdInput] = useState("");
  const [commentInput, setCommentInput] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [deletingUserId, setDeletingUserId] = useState(null);

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await API.fetchWl();
      setItems(res.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!show) return;
    fetch();
  }, [show]);

  const onDelete = async (userId) => {
    setDeletingUserId(userId);
    try {
      await API.deleteWl(userId);
      await fetch();
    } finally {
      setDeletingUserId(null);
    }
  };

  const showForm = () => {
    setForm(true);
  };

  const changeUserId = (event) => {
    const { value } = event.target;
    setUserIdInput(value);
  };

  const changeComment = (event) => {
    const { value } = event.target;
    setCommentInput(value);
  };

  const hideForm = () => {
    setUserIdInput("");
    setCommentInput("");
    setForm(false);
  };

  const saveForm = async () => {
    setIsSaving(true);
    try {
      await API.saveWl({
        UserId: userIdInput,
        comment: commentInput,
      });
      hideForm();
      await fetch();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} size="md" backdrop="static" onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title className={styles.title}>
          <i className="bi bi-people-fill"></i>&nbsp;Додатковий доступ
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.body}>
        <div className={styles.content} aria-busy={loading}>
            <div className={styles.toolbar}>
              <div>
                <div className={styles.sectionTitle}>Учасники</div>
                <div className={styles.hint}>
                  Керування додатковим доступом до гри.
                </div>
              </div>
              {!form && (
                <Button className={styles.addButton} onClick={showForm}>
                  <i className="bi bi-plus-lg" aria-hidden="true" />
                  <span>Додати учасника</span>
                </Button>
              )}
            </div>

            {form && (
              <Form className={styles.form}>
                <Form.Group
                  className={styles.field}
                  controlId="white-list-user-id"
                >
                  <Form.Label>User ID</Form.Label>
                  <Form.Control
                    value={userIdInput}
                    placeholder="Наприклад, 123456"
                    onChange={changeUserId}
                    autoFocus
                  />
                </Form.Group>
                <Form.Group
                  className={styles.field}
                  controlId="white-list-comment"
                >
                  <Form.Label>Коментар</Form.Label>
                  <Form.Control
                    value={commentInput}
                    placeholder="Необов'язково"
                    onChange={changeComment}
                  />
                </Form.Group>
                <div className={styles.formActions}>
                  <Button
                    variant="outline-secondary"
                    disabled={isSaving}
                    onClick={hideForm}
                  >
                    Скасувати
                  </Button>
                  <Button
                    disabled={!userIdInput.trim() || isSaving}
                    onClick={saveForm}
                  >
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          aria-hidden="true"
                        />
                        <span>Збереження...</span>
                      </>
                    ) : (
                      "Зберегти"
                    )}
                  </Button>
                </div>
              </Form>
            )}

            <div className={styles.list}>
              {items.length ? (
                items.map((item) => (
                  <Item
                    key={item.id}
                    userId={item.UserId}
                    comment={item.comment}
                    onDelete={onDelete}
                    isDeleting={deletingUserId === item.UserId}
                  />
                ))
              ) : !loading ? (
                <div className={styles.emptyState}>
                  <i className="bi bi-person-x" aria-hidden="true" />
                  <span>Список поки що порожній.</span>
                </div>
              ) : null}
            </div>
        </div>
        {loading && (
          <div
            className={styles.progressLine}
            role="progressbar"
            aria-label="Завантаження списку"
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default WhiteList;
